var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurposeBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.4821H11.5C10.95 16.4821 10.5 16.0321 10.5 15.4821H3.51V19.4821C3.51 20.5821 4.41 21.4821 5.51 21.4821H19.5C20.6 21.4821 21.5 20.5821 21.5 19.4821V15.4821H14.5C14.5 16.0321 14.05 16.4821 13.5 16.4821ZM20.5 7.48212H16.5C16.5 5.27212 14.71 3.48212 12.5 3.48212C10.29 3.48212 8.5 5.27212 8.5 7.48212H4.5C3.4 7.48212 2.5 8.38212 2.5 9.48212V12.4821C2.5 13.5921 3.39 14.4821 4.5 14.4821H10.5V13.4821C10.5 12.9321 10.95 12.4821 11.5 12.4821H13.5C14.05 12.4821 14.5 12.9321 14.5 13.4821V14.4821H20.5C21.6 14.4821 22.5 13.5821 22.5 12.4821V9.48212C22.5 8.38212 21.6 7.48212 20.5 7.48212ZM10.5 7.48212C10.5 6.38212 11.4 5.48212 12.5 5.48212C13.6 5.48212 14.5 6.38212 14.5 7.48212H10.49H10.5Z",
    fill: "#3D5DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurposeBusiness);
export default __webpack_public_path__ + "static/media/purpose_business.211c87e9a369991d94512bdfa8c8050c.svg";
export { ForwardRef as ReactComponent };